import { useParams } from 'react-router-dom';
import { TagCloud } from '@/components/blog/TagCloud';
import { PostList } from '@/components/blog/PostList';
import { Seo } from '@/components/seo/Seo';
import { Container } from '@/components/ui/Container';
import { usePostsByTag, useTags } from '@/hooks/usePosts';

export const TagsPage = (): React.JSX.Element => {
  const { tag } = useParams();
  const { posts, isLoading } = usePostsByTag(tag ?? '');
  const { tags } = useTags();

  if (tag) {
    return (
      <>
        <Seo title={`Tag: ${tag}`} description={`Posts tagged ${tag}.`} path={`/tags/${tag}`} />
        <Container>
          <section className="section-stack">
            <div className="section-heading">
              <h1>#{tag}</h1>
              {!isLoading && <p>{posts.length} post(s)</p>}
            </div>
            {!isLoading && <PostList posts={posts} />}
          </section>
        </Container>
      </>
    );
  }

  return (
    <>
      <Seo title="Tags" description="Browse tags on the PublishWeaver blog." path="/tags" />
      <Container>
        <section className="section-stack">
          <div className="section-heading">
            <h1>Tags</h1>
            <p>Browse the editorial taxonomy.</p>
          </div>
          <TagCloud tags={tags} />
        </section>
      </Container>
    </>
  );
};
